import { getEnv } from "env"
import config from "../server.config"

export const { BACKOFFICE_API_URL, API_TOKEN, AUTH_URL, LOGIN_URL, APP_ENV } =
  getEnv(config)
